(() => {
  const selector = '.product-card';
  const snapshots = new WeakMap();
  function remember(card) {
    if (snapshots.has(card)) return;
    const image = card.querySelector('.product-card-media img:not(.card-back-image)');
    const links = [...card.querySelectorAll(':scope > a')];
    const initialColor = card.querySelector('[data-card-color].is-selected')?.dataset.cardColor || '';
    snapshots.set(card, {image, links, initialColor});
  }
  function highlight(card, name) {
    const row = card.querySelector('.card-color-previews');
    if (!row) return;
    const options = [...row.querySelectorAll('[data-card-color]')];
    const chosen = options.find(option => option.dataset.cardColor === name);
    if (chosen?.hidden) row.prepend(chosen);
    [...row.querySelectorAll('[data-card-color]')].forEach((option, index) => {
      option.hidden = index >= 4;
      const active = option === chosen;
      option.classList.toggle('is-selected', active);
      if (active) option.setAttribute('aria-current', 'true');
      else option.removeAttribute('aria-current');
    });
  }
  function select(event) {
    const swatch = event.target.closest('a[data-card-color]');
    if (!swatch || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const card = swatch.closest(selector);
    if (!card || !swatch.dataset.previewSrc) return;
    remember(card);
    const state = snapshots.get(card);
    if (!state.image) return;
    const target = new URL(swatch.href, location.origin);
    if (target.origin !== location.origin) return;
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id', preview);
    event.preventDefault();
    state.image.srcset = swatch.dataset.previewSrcset || '';
    state.image.src = swatch.dataset.previewSrc;
    state.image.alt = swatch.dataset.previewAlt || '';
    state.links.forEach(link => { link.href = target.href; });
    card.dataset.cardColorActive = swatch.dataset.cardColor;
    highlight(card, swatch.dataset.cardColor);
  }
  function sync() {
    document.querySelectorAll(selector).forEach(card => {
      if (!card.querySelector('.card-color-previews')) return;
      remember(card);
      if (!card.hasAttribute('data-color-family-card')) return;
      delete card.dataset.cardColorActive;
      const slug = card.dataset.matchedColor;
      if (slug) {
        const match = [...card.querySelectorAll('[data-card-color]')].find(option => option.dataset.colorSlug === slug);
        highlight(card, match?.dataset.cardColor || '');
      } else {
        highlight(card, snapshots.get(card).initialColor);
      }
    });
  }
  document.addEventListener('click', select);
  document.addEventListener('catalog:updated', sync);
  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
